export default __webpack_public_path__ + "static/media/checkers-2-lqMAX.9ad92ab9.jpg";